import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticClass:"mt-4",attrs:{"type":"number","label":_vm.$t('pricingPrepayment'),"dense":"","error-messages":_vm.errorMessages},model:{value:(_vm.displayPrepayment),callback:function ($$v) {_vm.displayPrepayment=$$v},expression:"displayPrepayment"}})}
var staticRenderFns = []

export { render, staticRenderFns }